/*
*  Services content (copied from the original site)
*  - summary / icon: the "We Specialise in" cards on the home page
*  - the rest: the sections on the services page (id = the #anchor the cards link to)
*/

export const CONVEYANCING = {
  id: "conveyancing",
  cardTitle: "Conveyancing & Property Law",
  summary: "We provide expert conveyancing services, ensuring smooth transactions and protecting your interests whether buying or selling as well as in other aspects of property law.",
  icon: "/images/icon-attorney.png",
  title: "Conveyancing &",
  scriptTitle: "Property Law",
  image: "/images/banner-house.jpg",
  imageAlt: "A couple receiving the keys to their new home",
  intro: [
    "Conveyancing refers to the legal process of transferring ownership of immovable property from the Seller (owner) to the Purchaser, commonly known as a property transfer. A conveyancer is a legal professional specialising in the transfer of property ownership and is responsible for drafting and preparing the necessary deeds and documents to facilitate the registration of such transfers.",
    "Given that property is one of the most valuable assets an individual can own, it is essential to seek expert legal assistance to safeguard one’s interests and ensure the transaction is executed efficiently and in compliance with all legal requirements.",
  ],
  topics: [
    {
      title: "Property Transfers Process",
      paragraphs: [
        "The Conveyancer receives the Offer to Purchase or Sale Agreement and assumes responsibility for coordinating the transaction. Serving as the central point of communication, the Conveyancer facilitates interactions between the bond attorney, who registers the Purchaser’s new bond and the cancellation attorney, who oversees the cancellation of the Seller’s existing bond.",
        "Additionally, the Conveyancer collects all necessary personal information from the parties involved and obtains the required clearance figures and consents. This process ensures that all documentation is properly prepared for submission to the Deeds Office for registration.",
      ],
    },
    {
      title: "Sectional Title Scheme",
      paragraphs: [
        "Sectional title schemes continue to be hugely popular in South Africa with more and more people electing to move away from conventional standalone properties in exchange for the benefit of, among others, increased security, convenience and affordability that comes with a sectional title unit. However, it is crucial to understand the critical aspects of sectional title ownership to navigate the complexities effectively, protect your investment, and contribute to a harmonious communal environment. We can assist you with:",
      ],
      list: [
        "Opening of a new sectional title register and registration of the plans",
        "Conventional transfer of sectional title unit",
        "Application for the extension of a unit or the scheme",
        "Registration of amended sectional title plans",
        "Registration or allocation of exclusive use areas",
      ],
    },
    {
      title: "Township Establishment, Consolidation & Subdivision",
      paragraphs: [
        "In South Africa, land use is strictly regulated, and property owners are required to utilise their land in accordance with its designated registration purpose. Township establishment involves the process of converting land, usually farmland, into a township by opening a Township Register. This register maps out the land into streets and individual erven according to the general plan. When the owners of two or more parcels of land seek to merge them into a single property, this procedure referred to as, Consolidation must be carried out in compliance with South African property law. The law also allows for the division of a larger property into smaller pieces through a legal process called Subdivision.",
      ],
    },
    {
      title: "Estate transfers, Partition transfers, Endorsements, Lost Deeds & Servitudes",
      paragraphs: [
        "Our conveyancing services range over a spectrum of conventional and complex property aspects.",
      ],
    },
  ],
};

export const NOTARY = {
  id: "notary",
  cardTitle: "Notary Services",
  summary: "A notary in South Africa is a specialised attorney capable of dealing with amongst other things registration of marriage contracts, document authentication or notarisation / legalisation and drafting of specialised deeds.",
  icon: "/images/icon-stamp.png",
  title: "Notary",
  scriptTitle: "Services",
  image: "/images/banner-2.jpg",
  imageAlt: "A document being signed beside a gavel and scales of justice",
  intro: [
    "A Notary Public is an admitted attorney who passed the additional notarial examination. They are admitted and enrolled as a Notary Public by the High Court of South Africa and thereby authorised to practice in certain areas of law that attorneys without this relevant qualification, may not.",
    "The services of a Notary Public is usually required for the drawing of an marriage contract (antenuptial agreement), certify or authenticate a document for use inside or outside the borders of South Africa or draw and attest certain specific contracts and statements.",
    "Only a Notary Public can draft the following documents which is then signed and witnessed in the presence of the Notary Public:",
  ],
  introList: [
    "Antenuptial contract and Postnuptial contracts",
    "Servitudes (personal and praedial)",
    "Notarial bonds",
    "Notarial deeds of cession",
    "Cession of Rights in Sectional Title schemes",
    "Long-term Leases",
    "Trust deeds",
    "Deeds of donation",
  ],
  topics: [
    {
      title: "Apostille and Authentication",
      paragraphs: [
        "When you need to use documents signed or prepared in South Africa overseas, you will need the assistance and service of a Notary Public for the legalisation of such documents which include attestation, apostille, authentication and notarisation.",
        "Legalisation of documents means that official (public) documents to be used internationally are affixed, sealed and signed with either an Apostille Certificate or a Certificate of Authentication, attached thereto.",
        "Whether an Apostille Certificate (where countries are party of The Hague Convention, to which South Africa is a party) or a Certificate of Authentication (where countries are not party of The Hague Convention) is required, will depend on the country the documentation is being sent to.",
      ],
    },
    {
      title: "Documents that a Notary Public can certify as a true copy",
      paragraphs: [
        "A Notary Public may certify a wide range of documents as a true copy of the original.  The original document must be presented to the Notary Public to certify same.  This may include documents to be used within the Republic or outside the borders of South Africa, depending on the requirements of the country the document is sent to.",
      ],
      list: [
        "Marriage certificates",
        "Birth certificates",
        "Death certificates",
        "Single status Certificates",
        "Divorce certificates",
        "Police clearance certificates",
        "Powers of attorney",
        "Copies of identity documents or passports",
        "Educational documents",
      ],
    },
    {
      title: "Marriage Out of Community of Property: Exclusion of Accrual System",
      paragraphs: [
        "Requires explicit exclusion of the accrual system in the antenuptial contract to ensure it does not apply.  Each spouse keeps their own estate. Assets and liabilities owned before and acquired during the marriage or civil union remain separate and the exclusive property and liability of that person.",
      ],
    },
    {
      title: "Marriage Out of Community of Property: Including the Accrual System",
      paragraphs: [
        "Accrual only becomes relevant at the end of the marriage or civil union (on death or divorce).  The accrual allows for the sharing of assets and liabilities accumulated during the course of the marriage or civil union.  At the dissolution of the marriage or civil union, the party whose estate shows no growth or has a smaller growth compared to the other party, will be entitled to claim half of the difference between the growths of both estates.",
        "Exclusions from the accrual – certain assets belonging to either spouse are automatically excluded from the accrual calculations.",
      ],
    },
  ],
};

export const DECEASED_ESTATE = {
  id: "deceased-estate",
  cardTitle: "Deceased Estate Administration",
  summary: "Deceased estate administration ensures compliance with legal requirements, from reporting the estate to distributing assets per the will or intestate succession law.",
  icon: "/images/icon-testament.png",
  beforeScript: "Deceased",
  scriptTitle: "Estate",
  afterScript: "Administration",
  intro: [
    "We understand that navigating the legal aspects of estate administration during a time of loss can feel overwhelming. In the midst of grief, handling these responsibilities may seem daunting, but having a clear understanding of the process can bring some clarity and ease.",
    "The first step is to determine whether your loved one left a valid will. If they did, their will serves as a guide to their final wishes and appoints an executor to carry them out. If no will exists, the estate follows intestate administration, where inheritance is determined by the laws of succession.",
    "To ensure the proper administration of a deceased estate in South Africa, it is essential to follow the procedures set out in the Administration of Deceased Estates Act 66 of 1965. Below is a summary of the key steps in the estate administration process:",
  ],
  steps: [
    {
      title: "Report the Estate to the Master of the High Court",
      text: "The estate must be formally reported to the Master of the High Court in the jurisdiction where the deceased resided.",
    },
    {
      title: "Publish a Notice in the Gazette and Newspapers",
      text: "A formal notice must be published in the Government Gazette and local newspapers to inform creditors of the deceased's passing. This allows them to submit any claims against the estate within the prescribed period.",
    },
    {
      title: "Settle Outstanding Financial Affairs",
      text: "All debts, taxes, and other financial obligations of the deceased must be settled before distributing the remaining assets.",
    },
    {
      title: "Distribute Assets According to the Will",
      text: "If the deceased left a valid will, the appointed executor will distribute the estate according to the deceased’s wishes.",
    },
    {
      title: "Fulfil Additional Legal Requirements",
      text: "Depending on the complexity of the estate, additional legal and administrative steps may be required, such as obtaining final approvals from the Master’s office before concluding the process.",
    },
  ],
  image: "/images/banner-3.jpg",
  imageAlt: "Two people shaking hands across a desk",
};

export const ESTATE_PLANNING = {
  id: "estate-planning",
  cardTitle: "Estate Planning",
  summary: "A will ensures your estate, minor children, and chosen beneficiaries are cared for efficiently and cost-effectively.",
  icon: "/images/icon-will.png",
  beforeScript: "Wills &",
  scriptTitle: "Testament",
  intro: [
    "Having a legally valid, binding, and enforceable will is essential to ensure that your assets are distributed according to your wishes. The Wills Act sets out specific legal requirements that must be met for a will to be considered valid.",
    "To ensure your will accurately reflects your intentions and that your beneficiaries receive their rightful inheritance, it is crucial to review and update it annually. Your original will and testament will be securely archived.   You can reach out whenever any amendments are necessary.",
  ],
};

export const SERVICES = [CONVEYANCING, NOTARY, DECEASED_ESTATE, ESTATE_PLANNING];
